// src/features/mech/casting/questions/ProcessInvolved.jsx
import React from "react";
import { Box, Checkbox, Switch } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import PerlTextField from "../../../../shared/components/PerlTextField";
import PerlLabelMedium from "../../../../shared/components/PerlLabelMedium";
import PerlLabelSmall from "../../../../shared/components/PerlLabelSmall";
export default function ProcessInvolved({ value, onChange }) {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {
    white: "#ffffff",
    textPrimary: "#F1F2F3",
    textSecondary: "#9097A1",
  };
  const brandColor =
    theme.custom?.perlColors?.brandColor || theme.palette?.primary?.main || "#ff6034";

  // Parse the value object or initialize with empty strings-sand balsting, deburing, Heat treatment

  const processValue = value || {
    sandBlasting: false,
    deburing: false,
    heatTreatment: false
  };

  const handleFieldChange = (field, newValue) => {
    onChange?.({
      ...processValue,
      [field]: newValue,
    });
  };

  return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
        <PerlLabelMedium sx={{ mb: 1, display: "block" }}>Select the process involved:</PerlLabelMedium>

        <Box
            sx={{
                display: "flex",
                gap: 1,
                justifyContent: "space-between",
                alignItems: "center",
                // border: `1px solid ${perlColors.border}`,
                // borderRadius: 2,
                p: 0.5,
                // bgcolor: alpha(perlColors.white, 0.02),
            }}
            >
            <PerlLabelSmall sx={{ mb: 1, display: "block" }}>Sand Blasting</PerlLabelSmall>
            <Switch
                checked={Boolean(processValue.sandBlasting)}
                onChange={(e) => handleFieldChange("sandBlasting", e.target.checked)}
                color= {perlColors.backgroundColor}
                sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: perlColors.brandColor,
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                              backgroundColor: perlColors.brandColor,
                            },
                            "& .MuiSwitch-switchBase": {
                              color: "#7e8080ff",
                              backgroundColor: perlColors.backgroundColor,
                            },
                            "& .MuiSwitch-track": {
                              color: perlColors.backgroundColor,
                              backgroundColor: "#7e8080ff",
                            },
                          }}
            />
        </Box>

        <Box
            sx={{
                display: "flex",
                gap: 1,
                justifyContent: "space-between",
                alignItems: "center",
                // border: `1px solid ${perlColors.border}`,
                // borderRadius: 2,
                p: 0.5,
                // bgcolor: alpha(perlColors.white, 0.02),
            }}
            >
            <PerlLabelSmall sx={{ mb: 1, display: "block" }}>Deburring</PerlLabelSmall>
            <Switch
                checked={Boolean(processValue.deburing)}
                onChange={(e) => handleFieldChange("deburing", e.target.checked)}
                color= {perlColors.backgroundColor}
                sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: perlColors.brandColor,
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                              backgroundColor: perlColors.brandColor,
                            },
                            "& .MuiSwitch-switchBase": {
                              color: "#7e8080ff",
                              backgroundColor: perlColors.backgroundColor,
                            },
                            "& .MuiSwitch-track": {
                              color: perlColors.backgroundColor,
                              backgroundColor: "#7e8080ff",
                            },
                          }}
            />
        </Box>

        <Box
            sx={{
                display: "flex",
                gap: 1,
                justifyContent: "space-between",
                alignItems: "center",
                // border: `1px solid ${perlColors.border}`,
                // borderRadius: 2,
                p: 0.5,
                // bgcolor: alpha(perlColors.white, 0.02),
            }}
            >
            <PerlLabelSmall sx={{ mb: 1, display: "block" }}>Heat Treatment</PerlLabelSmall>
            <Switch
                checked={Boolean(processValue.heatTreatment)}
                onChange={(e) => handleFieldChange("heatTreatment", e.target.checked)}
                color= {perlColors.backgroundColor}
                sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: perlColors.brandColor,
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                              backgroundColor: perlColors.brandColor,
                            },
                            "& .MuiSwitch-switchBase": {
                              color: "#7e8080ff",
                              backgroundColor: perlColors.backgroundColor,
                            },
                            "& .MuiSwitch-track": {
                              color: perlColors.backgroundColor,
                              backgroundColor: "#7e8080ff",
                            },
                          }}
            />
        </Box>


      </Box>
    );
  }
